import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import bg from "../../../assets/landing2.jpg";
import bg2 from "../../../assets/landing3.jpg";
import card from "../../../assets/cardsbg.jpeg";

const cardVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      delay: i * 0.2,
      ease: "easeOut",
    },
  }),
};

const CardsPage = () => {
  return (
    <section className="py-24 px-4 bg-background-soft" style={{backgroundImage: `url(" ${card} ")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'}}>
      <div className="grid md:grid-cols-2 gap-6 max-w-7xl mx-auto">
        
        {/*  CARD 1  */}
        <motion.div
          custom={0}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          whileHover={{ scale: 1.02 }}
          className="relative h-[400px] overflow-hidden shadow-lg bg-center bg-cover"
          style={{ backgroundImage: `url(${bg})` }}
        >
          <div className="absolute inset-0 bg-black/40" />

          {/* Content */}
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-50 mb-3">
              Explore Our Menu
            </h2>

            <p className="text-primary-100/90 mb-6 max-w-md">
              Discover a variety of delicious dishes crafted with fresh
              ingredients.
            </p>

            <Link to="/menu">
              <motion.button
                whileHover={{ scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 rounded-full bg-background-soft text-primary-900 font-medium hover:bg-primary-900 hover:text-primary-50 transition"
              >
                View Menu
              </motion.button>
            </Link>
          </div>
        </motion.div>

        {/* CARD 2  */}
        <motion.div
          custom={1}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          whileHover={{ scale: 1.02 }}
          className="relative h-[400px] overflow-hidden shadow-lg bg-center bg-cover"
          style={{ backgroundImage: `url(${bg2})` }}
        >
          <div className="absolute inset-0 bg-black/40" />

          {/* Content */}
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-50 mb-3">
              Book a Table
            </h2>

            <p className="text-primary-100/90 mb-6 max-w-md">
              Reserve your spot and enjoy a memorable dining experience with us.
            </p>

            <Link to="/contact">
              <motion.button
                whileHover={{ scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 rounded-full bg-background-soft text-primary-900 font-medium hover:bg-primary-900 hover:text-primary-50 transition"
              >
                Book Now
              </motion.button>
            </Link>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default CardsPage;
